import * as DomainBaseFieldIDs from "../../constants/DomainBaseFieldIDs";
import * as CommonFieldIds from "../../constants/CommonFieldIds";
import * as IsLeafEntities from "../../constants/EntitiesWithLedgerEffectsOrWithParents";
import {JSCriteriaBuilder} from "../../common/JSCriteriaBuilder";
import * as Operator from "../../constants/Operator";
import * as NamaURLS from "../../constants/NamaURLS";
import * as ObjectChecker from "../../common/NamaCommon";
import {ajaxJSONWithoutWait} from "../../common/NamaCommon";
import * as trans from "../../common/Translator";
import {getCustomGUISettings} from "../../login/ClientCache";
import {PMNaMaTreeNode} from "./PMNaMaTreeNode";
import * as ExpressionRelationship from "../../constants/ExpressionRelationship";

let code = CommonFieldIds.CODE;
let id = CommonFieldIds.ID;
let parentId = CommonFieldIds.PARENT + "." + id;
let name1 = CommonFieldIds.NAME1;
let name2 = CommonFieldIds.NAME2;
let orderBy = parentId;
let isLeaf = "isLeaf";
let parent = CommonFieldIds.PARENT;

export class TreeModelProvider {

    constructor(entityType, listedEntityType) {
        let that = this;
        that.entityType = entityType;
        that.listedEntityType = listedEntityType;
        that.columnsToGet = [id, code, name1, name2, parentId];
        if (entityHasIsLeafProperty(entityType))
            that.columnsToGet.push(isLeaf);
    }

    createCriteria() {
        let that = this;
        let criteria = new JSCriteriaBuilder();
        criteria.expressions = [];
        if (that.listedEntityType) {
            criteria.expressions.push({
                field: DomainBaseFieldIDs.MasterGroup_forType,
                operator: Operator.Equal,
                rightHandSide: that.listedEntityType,
                relation: ExpressionRelationship.AND
            });
        }
        return criteria;
    }

    createRequest() {
        let that = this;
        let columns = that.columnsToGet;
        /**
         *
         * @type {namaTypes.DTOSearchResultSettings}
         */
        let searchResultSettings = {
            pageData: {pageNumber: 0, pageSize: -1}, sortByColumn: orderBy, columnsToGet: columns
        };
        /**
         *
         * @type {namaTypes.SearchRequest}
         */
        let request = {entityType: that.entityType, criteria: that.createCriteria(), searchResultSettings: searchResultSettings};
        return request;
    }

    getNodes(callBack) {
        let that = this;
        let request = that.createRequest();
        ajaxJSONWithoutWait(NamaURLS.Search, {
            request: JSON.stringify(request)
        }, (result) => {
            let roots = that.groupInAllRootIfNeeded(that.createNodes(result));
            callBack(roots);
        });
    }

    groupInAllRootIfNeeded(nodes) {
        if (nodes && nodes.length == 1)
            return nodes;
        let roots = [];
        let root = new PMNaMaTreeNode("", trans.translateId('theAll'), trans.translateId('theAll'), false);
        roots.push(root);
        if (nodes) {
            for (let node of nodes) {
                root.addChild(node);
            }
        }
        return roots;
    }

    createNodes(result) {
        let page = result.list;
        let nodesMap = new Map();
        let roots = [];
        for (let pageObject of page) {
            let object = pageObject.values;
            if (!nodesMap.has(object["id"])) {
                let node = new PMNaMaTreeNode(object["id"], calcByLanguage(object["code"], object["altCode"]), getName(object), object["isLeaf"]);
                if (object["parent.id"])
                    node.parentID = object["parent.id"];
                else
                    roots.push(node);
                nodesMap.set(node.id, node);
            }
        }
        for (let [nodeId, node] of nodesMap) {
            {
                if (node.parentID) {
                    let actualParent = nodesMap.get(node.parentID);
                    if (actualParent)
                        actualParent.addChild(node);
                }
            }
        }
        return roots;
    }
}

function getName(object) {
    if (!getCustomGUISettings.doNotUseDescriptorsInFields)
        return getNameConsideringDescriptors(object);
    let firstNotEmptyObj = ObjectChecker.getFirstNotEmptyObj(calcByLanguage(object.name1, object.name2), object.code, object.id);
    return firstNotEmptyObj ? firstNotEmptyObj : "";

}

function getNameConsideringDescriptors(object) {
    if (!object)
        return null;
    let name = ObjectChecker.getFirstNotEmptyObj(calcByLanguage(object.descriptor1, object.descriptor2),
        calcByLanguage(object.name1, object.name2), object.code, object.id);
    return name ? name : "";
}

export function calcByLanguage(arabicText, englishText) {
    if (trans.isArabic())
        return ObjectChecker.getFirstNotEmptyObj(arabicText, englishText);
    return ObjectChecker.getFirstNotEmptyObj(englishText, arabicText);
}

function entityHasIsLeafProperty(entityType) {
    return (IsLeafEntities.HAS_IS_LEAF_ENTITIES.binarySearch(entityType) >= 0);
}